<!--
  @description 业务拨测-处理终端登录
  @author xiehan
  @date 2018/12/03
-->
<template>
  <div class="handlerDialTermianl__content">
    <g-back :history="history"></g-back>
    <el-form ref="handlerForm" :model="handlerForm" label-width="90px" :rules="rules" :inline="true">
      <div class="el-wrap-width">
        <el-form-item :label="$t('dial.name')" prop="name">
          <el-input v-model="handlerForm.name"></el-input>
        </el-form-item>
      </div>
      <div class="el-wrap-width">
        <el-form-item :label="$t('dial.desc')" prop="desc">
          <el-input v-model="handlerForm.desc"></el-input>
        </el-form-item>
      </div>
      <el-form-item :label="$t('dial.frequency')" prop="frequency" input-width="auto">
        <el-radio-group v-model="handlerForm.frequency">
          <el-radio :label="1">{{ $t('dial._1minutes') }}</el-radio>
          <el-radio :label="5">{{ $t('dial._5minutes') }}</el-radio>
          <el-radio :label="15">{{ $t('dial._15minutes') }}</el-radio>
          <el-radio :label="30">{{ $t('dial._30minutes') }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <div class="el-wrap-width">
        <el-form-item :label="$t('dial.availability')" prop="availability">
          <el-input v-model.number="handlerForm.availability">
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
      </div>
      <div class="el-wrap-width">
        <el-form-item :label="$t('dial.duration')" prop="duration">
          <el-input v-model.number="handlerForm.duration">
            <template slot="append">{{ $t('dial.minutes') }}</template>
          </el-input>
        </el-form-item>
      </div>
      <div class="el-wrap-width">
        <el-form-item :label="$t('dial.trigDelay')" prop="trigDelay">
          <el-input v-model.number="handlerForm.trigDelay">
            <template slot="append">ms</template>
          </el-input>
        </el-form-item>
      </div>
      <div class="el-wrap-width_both">
        <el-form-item label="IP" prop="ip">
          <el-input v-model="handlerForm.ip"></el-input>
        </el-form-item>
        <el-form-item label="PORT" prop="port">
          <el-input v-model.number="handlerForm.port"></el-input>
        </el-form-item>
      </div>
      <div class="el-wrap-width_both">
        <el-form-item :label="$t('dial.userName')" prop="userName">
          <el-input v-model="handlerForm.userName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dial.password')" prop="password">
          <el-input v-model="handlerForm.password"></el-input>
        </el-form-item>
      </div>
      <div class="el-wrap-width_both">
        <el-form-item label="IMEI" prop="imei">
          <el-input v-model="handlerForm.imei"></el-input>
        </el-form-item>
        <el-form-item label="SID" prop="sid">
          <el-input v-model="handlerForm.sid"></el-input>
        </el-form-item>
      </div>
      <div class="el-wrap-width_both">
        <el-form-item label="LoginType" prop="loginType">
          <el-input v-model.number="handlerForm.loginType"></el-input>
        </el-form-item>
        <el-form-item label="CellId" prop="cellId">
          <el-input v-model.number="handlerForm.cellId"></el-input>
        </el-form-item>
      </div>
      <div class="el-wrap-width_both">
        <el-form-item label="Lac" prop="lac">
          <el-input v-model.number="handlerForm.lac"></el-input>
        </el-form-item>
        <el-form-item label="SeedIms" prop="seedIms">
          <el-input v-model="handlerForm.seedIms"></el-input>
        </el-form-item>
      </div>
      <el-form-item label="Condition" prop="condition" input-width="470px">
        <el-input
          type="textarea"
          :rows="2"
          v-model="handlerForm.condition">
        </el-input>
      </el-form-item>
      <div style="margin-left: 90px;">
        <el-button type="primary" 
          @click="handlerTermianLogon('testTerminalLogin')"
          v-text="$t('dial.test')"
          v-g-rac="gRac('dialTerminal_test')">
        </el-button>
        <el-button type="primary" 
          @click="saveEvent"
          v-text="$t('common.save')"
          v-g-rac="gRac('dialTerminal_save')">
        </el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
  import rac from '@/plugins/rac-mixin'
  import dialBiz from '@/logic/intelligentMonitor/dialBiz'
  import { extend } from '@/utils/tool'
  export default {
    mixins: [rac],
    data () {
      return {
        history: [],
        handlerForm: {
          name: '',
          desc: '',
          frequency: 1,
          availability: '',
          duration: '',
          trigDelay: '',
          ip: '',
          port: '',
          userName: '',
          password: '',
          imei: '',
          sid: '',
          loginType: '',
          cellId: '',
          lac: '',
          seedIms: '',
          type: 'TCPEP',
          condition: ''
        },
        rules: {
          name: [
            { required: true, message: `${this.$t('common.entryTips')}${this.$t('dial.name')}` }
          ],
          desc: [
            { required: true, message: `${this.$t('common.entryTips')}${this.$t('dial.desc')}` }
          ],
          availability: [
            { required: true, message: `${this.$t('common.entryTips')}${this.$t('dial.available')}` },
            { type: 'number', message: `${this.$t('dial.available')}${this.$t('dial.mustInt')}` }
          ],
          duration: [
            { required: true, message: `${this.$t('common.entryTips')}${this.$t('dial.duration')}` },
            { type: 'number', message: `${this.$t('dial.duration')}${this.$t('dial.mustInt')}` }
          ],
          trigDelay: [
            { required: true, message: `${this.$t('common.entryTips')}${this.$t('dial.delay')}` },
            { type: 'number', message: `${this.$t('dial.delay')}${this.$t('dial.mustInt')}` }
          ],
          ip: [
            { required: true, message: `${this.$t('common.entryTips')}IP` }
          ],
          port: [
            { required: true, message: `${this.$t('common.entryTips')}PORT` },
            { type: 'number', message: `PORT${this.$t('dial.mustInt')}` }
          ],
          password: [
            { required: true, message: `${this.$t('common.entryTips')}${this.$t('dial.password')}` }
          ],
          userName: [
            { required: true, message: `${this.$t('common.entryTips')}${this.$t('dial.userName')}` }
          ],
          imei: [
            { required: true, message: `${this.$t('common.entryTips')}IMEI` }
          ],
          sid: [
            { required: true, message: `${this.$t('common.entryTips')}SID` }
          ],
          loginType: [
            { required: true, message: `${this.$t('common.entryTips')}LoginType` },
            { type: 'number', message: `LoginType${this.$t('dial.mustInt')}` }
          ],
          cellId: [
            { required: true, message: `${this.$t('common.entryTips')}CellId` },
            { type: 'number', message: `CellId${this.$t('dial.mustInt')}` }
          ],
          lac: [
            { required: true, message: `${this.$t('common.entryTips')}Lac` },
            { type: 'number', message: `Lac${this.$t('dial.mustInt')}` }
          ],
          seedIms: [
            { required: true, message: `${this.$t('common.entryTips')}SeedIms` }
          ]
        }
      }
    },
    methods: {
      setHistory (name) {
        this.history = []
        this.history.push({ name: name || this.$t('dial.addTerminalTask') })
      },
      checkCondition () {
        try {
          if (typeof JSON.parse(this.handlerForm.condition) !== 'object') {
            this.warningTips()
            return false
          }
        } catch (err) {
          this.warningTips()
          return false
        }
        return true
      },
      warningTips () {
        this.$message({
          message: `condition${this.$t('dial.objectTips')}`,
          type: 'warning'
        })
      },
      saveEvent () {
        this.handlerTermianLogon(this.$route.query.id ? 'update' : 'save')
      },
      handlerTermianLogon (interfaceName) {
        this.$refs['handlerForm'].validate((valid) => {
          if (valid) {
            let obj = extend(true, {}, this.handlerForm)
            if (this.handlerForm.condition) {
              if (!this.checkCondition()) return
              obj.condition = JSON.parse(obj.condition)
            } else {
              delete obj.condition
            }
            if (interfaceName === 'update') obj.id = this.$route.query.id
            this.dynamicsRequest(interfaceName, { ...obj })
          } else {
            return false
          }
        })
      },
      dynamicsRequest (name, params) {
        dialBiz[name](params).then(data => {
          this.successMessage()
          if (name !== 'testTerminalLogin') this.$router.push({ name: 'dial' })
        })
      },
      successMessage () {
        this.$message({
          message: this.$t('common.success'),
          type: 'success'
        })
      },
      getDialInfo () {
        dialBiz.getDialById({ id: this.$route.query.id }).then(data => {
          this.setHistory(data.name)
          this.setHandlerForm(data)
        })
      },
      setHandlerForm (data) {
        for (let i in this.handlerForm) {
          if (i === 'condition' && data[i]) {
            this.handlerForm[i] = JSON.stringify(data[i])
          } else {
            this.handlerForm[i] = data[i]
          }
        }
      }
    },
    watch: {
      $route (to, from) {
        if (to.name === 'handlerDialTermianl' && from.name === 'dial') {
          if (this.$route.query.id) {
            this.getDialInfo()
          } else {
            this.$refs.handlerForm.clearValidate()
            this.$refs.handlerForm.resetFields()
            this.setHistory()
          }
        }
      }
    },
    mounted () {
      if (this.$route.query.id) {
        this.getDialInfo()
      } else {
        this.setHistory()
      }
    }
  }
</script>

<style scoped>
  .el-wrap-width {
    width: 290px;
  }
  .el-wrap-width_both {
    width: 580px;
  }
</style>